class SendPaymentCartaoError extends Error {
  constructor(cause, url, props, code = 'GET_PAYMENT_CARTAO_ERROR') {
    super("Falha ao gerar pagamento por cartão");
    this.name = 'SendPaymentCartaoError';
    this.code = code;
    this.cause = cause;
    this.url = url;
    this.props = props;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, SendPaymentCartaoError);
    }
  }
}

module.exports = SendPaymentCartaoError;